import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import config from '../../config';
/* import { history } from '../../routes';
import { getOwner } from '../../libraries/utils'; */

import ActionCard from '../../components/customs/ActionCard';
import Loader from '../../components/commons/Loader';
import Icon from '../../libraries/icons';


import actionsAction from "../../context/actions/actions";
import categoriesAction from '../../context/categories/actions';

import Instructive from '../../components/commons/Instructive';

import { ToastContainer, notify } from '../../libraries/notifications';
import LayoutDesktop from '../../components/layout/LayoutDesktop';
import LayoutWithSidebar from '../../components/layout/LayoutWithSidebar';
import BottomNav from '../../components/commons/BottomNav';
import LayoutResponsive from '../../components/layout/LayoutResponsive';
import actions from '../../context/settings/actions';
import img_no_downloaded from '../../assets/img/onboarding/no-bajar-fotos.png'
import ButtonIcon from '../../components/commons/ButtonIcon';


// "Mi Comunidad" es la categoria donde cada empresa sube sus acciones propias.
// Va siempre fija al inicio del listado; el resto, en orden alfabetico.
// Si en la DB el nombre difiere/esta traducido, el match no aplica y cae al
// orden alfabetico normal (degrada seguro, no rompe).
const COMMUNITY_CATEGORY_NAME = 'Mi Comunidad';

const isCommunityCategory = (category) =>
  (category?.name || '').trim().toLowerCase() === COMMUNITY_CATEGORY_NAME.toLowerCase();

const sortCategoriesCommunityFirst = (categories) =>
  [...categories].sort((a, b) => {
    const aCommunity = isCommunityCategory(a);
    const bCommunity = isCommunityCategory(b);
    if (aCommunity !== bCommunity) return aCommunity ? -1 : 1;
    return a.name.localeCompare(b.name);
  });


class Actions extends React.Component {
  constructor(props) {
    super(props);
    this.t = this.props.t;
    this.scrollContainerRef = React.createRef();
    this.searchInputRef = React.createRef();
    this.searchTimer = null
    this.state = {
      actions: [],
      search: "",
      searchOpen: false,
      filters: {
        type: null
      },
      categories: [],
      event_settings: null,
      sliders: []
    }

  }

  async componentDidMount() {
    console.log('ACTIONS');
    const { state } = this.props.location;
    if (state && state.filters) {
      this.setState({ filters: state.filters })
    }
    await this.get_event_setting();
    await this.getCategories();
    await this.getActions();

  }

  componentDidUpdate(prevProps, prevState) {
    if(this.props.mode_app_settings?.item !== prevProps?.mode_app_settings?.item){
      const modoapp= this.props.mode_app_settings.item?.value || "normal"
      const sliders = config.INSTRUCTIVES[modoapp]?.SLIDERS_ACTIONS?.CONTENT ?? config.INSTRUCTIVES["normal"]?.SLIDERS_ACTIONS?.CONTENT
        this.setState({sliders:sliders})
   }
  }

  getActions = async () => {
    this.setState({ loading: true })
    const { filters } = this.state
    let params = {}

    if ((filters.type && filters.type !== "")) {
      this.setState({ actions: [] });
      params = {
        ...params,
        type: filters.type, 
        order_by: "order_index", 
        order_direction: "ASC",
        source: [this.props.auth.user.unique_id]
      }
    }

    await this.props.onGetAllActions({ ...params, enabled: 1 });
    const { actions } = this.props;
    if (actions.error) {
      notify(this.t(actions.error.message));
    } else {
      this.setState({ actions: actions.items });
    }
    this.setState({ loading: false })
  }


  getCategories = async (next) => {
    await this.props.onGetAllCategories({ type: config.TYPES.CATEGORIES.ACTIONS, order_by: 'order_index', order_direction: 'ASC' });
    const { categories } = this.props;
    if (categories.error) {
      notify(this.t(categories.error.message));
    } else {
      this.setState((prevState) => {
        if (prevState.filters.type) {
          return { categories: categories.items };
        } else {
          categories.items.sort((a, b) => a.name.localeCompare(b.name))
          return {
            categories: categories.items,
            filters: { type: categories.items[0] ? categories.items[0].id : null },
          };
        }
      });
    }
  }


  filterActions = (type) => {
    this.setState({ filters: { type } }, () => this.getActions())

  }
  scrollLeft = () => {
    if (this.scrollContainerRef.current) {
      this.scrollContainerRef.current.scrollBy({
        left: -200, // Desplaza 200px a la izquierda
        behavior: 'smooth',
      });
    }
  };

  scrollRight = () => {
    if (this.scrollContainerRef.current) {
      this.scrollContainerRef.current.scrollBy({
        left: 200, // Desplaza 200px a la derecha
        behavior: 'smooth',
      });
    }
  }
  renderContent = () => {
    const { actions, filters, categories, sliders } = this.state;
    return (
      <>
        
      </>
    )
  }

  get_event_setting = async () => {
    await this.props.onGetEventSettings({
      "type": "sharyco_settings",
      "code": "app_event",
      "owner": this.props.auth.user.unique_id
    });
    const {mode_app_settings} = this.props;
    if (mode_app_settings.error) {
      notify(this.t(mode_app_settings.error.message));
    } else {
      this.setState({event_settings:mode_app_settings.item})
    }
  }

  toggleSearch = () => {
    this.setState({ searchOpen: true }, () => {
      if (this.searchInputRef.current) {
        this.searchInputRef.current.focus();
      }
    });
  }

  closeSearch = () => {
    this.setState({ searchOpen: false, search: "" }, () => {
      this.onChangeFilterAction("");
    });
  }

  onChangeFilterAction = (value) => {
    this.setState({ search: value });
    clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(async () => {
      this.setState({ loading: true });
      // Filtrar por la fuente del usuario (igual que el fetch por categoría),
      // si no la búsqueda trae la acción original del sistema + la copia de la
      // empresa con el mismo nombre y aparece duplicada.
      let params = { enabled: 1, source: [this.props.auth.user.unique_id] };
      if (value && value !== "") {
        params.name = `%${value.toLowerCase()}%`
      }
      await this.props.onGetAllActions(params);
      const { actions } = this.props;
      if (actions.error) {
        notify(this.t(actions.error.message));
      } else {
        this.setState({ actions: actions.items });
      }
      this.setState({ loading: false });
    }, 500);
  }


  render() {
    const { actions, filters, categories, sliders } = this.state;

    return  (
      <LayoutResponsive
        main={{ className: "pb-14" }}
        header={{
          logo: true,
          //content: <NavButtonBar options={buttonBarUpper} active={topNav} onClick={this.onNavBarClick} />
        }}
      >
        <ToastContainer />
        <div className='px-5 border-t border-gray-100 relative'>
          {this.state.searchOpen ? (
            <div className="flex items-center gap-2 px-3 py-2">
              <input
                ref={this.searchInputRef}
                className="input input-bordered flex-1"
                placeholder={this.t("Buscar acciones...")}
                value={this.state.search}
                onChange={(e) => this.onChangeFilterAction(e.target.value)}
                onKeyDown={(e) => e.key === 'Escape' && this.closeSearch()}
              />
              <button className="btn btn-ghost btn-sm" onClick={this.closeSearch}>
                <Icon className="h-5 w-5" name="close" />
              </button>
            </div>
          ) : (
            <div className="scrolling-wrapper mx-3" ref={this.scrollContainerRef}>
              <button onClick={this.scrollLeft}>
                <Icon className="text-gray-300 absolute left-2 transform -translate-y-1/2 w-5 h-14 z-10" name="cheveron_left" onClick={this.scrollLeft} />
              </button>
              <button onClick={this.scrollRight}>
                <Icon className="text-gray-300 absolute right-2 transform -translate-y-1/2 w-5 h-14 z-10" name="cheveron_right" onClick={this.scrollRight} />
              </button>
              <button className="btn btn-ghost btn-square" onClick={this.toggleSearch}>
                <Icon className="h-5 w-5" name="search" />
              </button>
              {sortCategoriesCommunityFirst(categories)
                .map((category, index) => {
                  return (
                    <div
                      key={index}
                      className={"px-4 py-3 text-center border-b-4 border-transparent font-medium flex-1 rounded-none " + (category.id === filters.type ? " border-b-secondary font-semibold text-base-content " : " text-neutral ") + ""}
                      onClick={() => this.filterActions(category.id)}
                    >
                      <h5 className='whitespace-nowrap'>{this.t(category.name)}</h5>
                    </div>
                  );
                })}
            </div>
          )}
        </div>
        <div className="w-full mx-auto mb-12 lg:mb-4">
          {this.state.loading && (<Loader />)}
          {/* <section className="p-3">
            <Instructive
              slides={[
                {
                  title: "Tus acciones son las que suman",
                  body: "Tené en cuenta que las fotos que subís deben ser de acciones propias hechas dentro del último mes. ‘No son válidas’ acciones de terceros o imágenes bajadas de internet.",
                  img: 'img_no_downloaded'
                },
              ]}
              instructive={"show_acciones_confirm"}
              labelButton="Estoy de acuerdo"
            >
            </Instructive>
          </section> */}
         {
         <Instructive
            slides={sliders}
            instructive={"show_actions"}
          >
            <div className="grid gap-4 px-3 pt-5">
              {!this.state?.loading && !categories?.loading && actions?.length == 0 && (
                <div className='flex flex-col items-center gap-5 mt-5 text-neutral'>
                <Icon className="h-16 w-16" name="sad" />
                <p className="">{this.t("No hay acciones")}</p>
              </div>
              ) }
              {actions && actions.map((action, index) => {
                return (
                  <ActionCard
                    key={index}
                    data={action}
                    route={config.ROUTES.ACTIONS.DETAIL.replace(':id', action.id)}
                    filters={filters}
                  />
                )
              })
              }
            </div>
          </Instructive>}
        </div>
      </LayoutResponsive>

    ) 
  }
}

const mapStateToProps = state => {
  return {
    auth: state.users.auth,
    actions: state.actions.list,
    categories: state.categories.list,
    mode_app_settings: state.settings.appmode,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onGetAllActions: (params) => dispatch(actionsAction.getAll(params)),
    onGetAllCategories: (params) => dispatch(categoriesAction.getAll(params)),
    onGetEventSettings:(params)=>dispatch(actions.getAllEvent(params))

  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(Actions));

